import Spinner from '@/common/components/Spinner'
import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { Separator } from '@/common/ui/separator'
import useQueryGetCommissionById from '@/modules/promotion/api/hooks/useQueryGetCommissionById'
import { format } from 'date-fns'
import { Eye, PencilIcon } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
interface CommissionModalProps {
	commissionId: string
}

export const CommissionModal = ({ commissionId }: CommissionModalProps) => {
	const [open, setOpen] = useState(false)
	const { data: commission, isLoading } =
		useQueryGetCommissionById(commissionId)

	return (
		<>
			<Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
				<Eye className="h-4 w-4" />
			</Button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-[600px]">
					<DialogHeader>
						<DialogTitle>รายละเอียดคอมมิชชั่น</DialogTitle>
					</DialogHeader>

					{isLoading ? (
						<div className="flex items-center justify-center">
							<Spinner />
						</div>
					) : commission ? (
						<div className="space-y-4">
							<div className="flex justify-between">
								<div>
									<h3 className="font-semibold">ชื่อ</h3>
									<p>{commission.name}</p>
								</div>
								<Button variant="outline" size="icon">
									<Link to={`/operator/commission/${commissionId}`}>
										<PencilIcon className="h-4 w-4" />
									</Link>
								</Button>
							</div>

							<Separator />
							<div>
								<h3 className="my-4 font-semibold">
									เปอร์เซ็นต์คอมมิชชั่นของแต่ละประเภทเกม (0-100%)
								</h3>
								<div className="grid grid-cols-2 gap-4">
									<div>
										<p>
											FISHING:{' '}
											{commission.creditRatio.FISHING.creditRatio !== null &&
											commission.creditRatio.FISHING.creditRatio !== undefined
												? String(
														Number(
															(
																commission.creditRatio.FISHING.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
									</div>
									<div>
										<p>
											SLOT:{' '}
											{commission.creditRatio.SLOT.creditRatio !== null &&
											commission.creditRatio.SLOT.creditRatio !== undefined
												? String(
														Number(
															(
																commission.creditRatio.SLOT.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
									</div>
									<div>
										<p>
											LOTTO:{' '}
											{commission.creditRatio.LOTTO.creditRatio !== null &&
											commission.creditRatio.LOTTO.creditRatio !== undefined
												? String(
														Number(
															(
																commission.creditRatio.LOTTO.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
									</div>
									<div>
										<p>
											SPORT:{' '}
											{commission.creditRatio.SPORT.creditRatio !== null &&
											commission.creditRatio.SPORT.creditRatio !== undefined
												? String(
														Number(
															(
																commission.creditRatio.SPORT.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
									</div>
									<div>
										<p>
											CASINO:{' '}
											{commission.creditRatio.CASINO.creditRatio !== null &&
											commission.creditRatio.CASINO.creditRatio !== undefined
												? String(
														Number(
															(
																commission.creditRatio.CASINO.creditRatio * 100
															).toFixed(4),
														),
													)
												: '0'}
											%
										</p>
									</div>
								</div>
							</div>
							<Separator />
							<div>
								<h3 className="font-semibold">ระยะเวลา</h3>
								<p>
									{commission.startDate &&
										format(new Date(commission.startDate), 'dd/MM/yyyy')}{' '}
									-{' '}
									{commission.endDate &&
										format(new Date(commission.endDate), 'dd/MM/yyyy')}
								</p>
							</div>
							<div>
								<h3 className="font-semibold">รอบเทิร์น</h3>
								<p>{commission.turnoverRound}</p>
							</div>

							<div className="flex justify-end gap-4 pt-4">
								<Button variant="outline" onClick={() => setOpen(false)}>
									ปิด
								</Button>
							</div>
						</div>
					) : null}
				</DialogContent>
			</Dialog>
		</>
	)
}
